<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../../public/images/sichuan/header.png")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入四川移动手机号")
        el-form-item
          el-col(:span="15")
            el-input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
          el-col(:span="9")
            el-button(type="primary", :disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          el-button(type="warning", @click="handelConfirm") 立即办理
        el-form-item
          el-checkbox(v-model="agreeProtocol")
          span.protocol-content
            | 我已阅读《
            span.protocol(@click="protocolVisible = true") 四川移动通信业务办理须知
            | 》
    .notice
      .title - 活动规则 -
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index", v-if="index <= 1 || showMoreNotice")
            .num {{index + 1}}.
            p.content {{notice}}
        .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多活动规则
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info 30元10G极速流量包-18个月合约版
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
    el-dialog(
      width="90%",
      title="四川移动通信业务办理须知",
      align="center"
      :visible.sync="protocolVisible"
    )
      .protocol-dialog-content
        div(v-for="item in protocol", :key="item") {{item}}
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '办理对象：四川移动用户（wap不限量套餐、数据卡、物联网卡、家庭共享成员等除外，主资费套餐价值38元及以下的新入网客户当月不能办理）。',
        '生效方式：订购立即生效，首月不区分上下半月，流量全额到账，可结转至次月使用，不可共享和转赠，订购第1个月至第9个月正常收费，第10个月至第18个月每月优惠等额话费。合约期到期后流量资费与活动自动取消。',
        '合约说明：该活动合约期为18个月，合约期间须使用由中国移动通信集团四川有限公司提供的相关通信服务，不能销号和过户。',
        '提前解约规则：客户如需提前解约，须到号码归属地营业厅办理解约，解约不收取违约金。',
        '其他限制：以上活动仅能参与一次，不能重复办理。',
        '套餐生效期间，2/3/4/5G网络通用，客户所有流量均可享受5G网络权益（须同时具备5G网络环境和5G终端）。若取消套餐，5G速率将同步失效。该流量包流量不适用于港澳台地区，套餐外流量按照当前套餐外规则执行。',
        '该活动数量有限，办完即止。',
        '办理前请您仔细阅读《四川移动通信业务办理须知》相关规定。'
      ],
      protocol: [
        '本业务受理单系客户与中国移动通信集团四川有限公司（以下统称移动公司）就客户已知其有其他消费选择，但仍自主选择移动公司某项通信业务营销活动的特别约定，并作为在此之前双方签订的相关服务协议（或约定）的补充条款。如本业务受理单的内容与双方之前签订的相关服务协议（或约定）有冲突的，以本业务受理单的说明或约定为准。',
        '一、相关定义',
        '1、月约定消费额：根据该项通信业务营销活动的业务资费标准或优惠条件所设定的客户每月通信消费约定金额。移动公司代其他服务商收取的各项费用、以及已明示不包含在内的其他费用不计入每月约定消费额度内。客户每月实际通信消费未达到前述月约定消费额时，客户仍应按照本业务受理单所约定的额度缴纳通信费用。',
        '2、划拨：预存划拨，移动公司从客户缴纳的预付（也称预存）费用中扣减通信费用的过程。赠送划拨，移动公司通过营销活动以赠送优惠方式抵扣通信费用的过程。',
        '3、赠送(含优惠)：客户承诺遵守本业务受理单的约定，而由移动公司给予客户的优惠方式，包括价格折扣，以及赠送费用、终端、产品、电子卷、红包等。客户如果要求提前终止相关业务或活动，或有违反约定的行为的，移动公司有权撤销赠送，有权要求客户返还或补偿或承担其他责任。（1）赠送通信费的，赠送的通信费用于按月抵扣客户当月产生的实际通信费（已明示不包含在内的其他费用不予抵扣）。如优惠通信费高于实际通信费的，该月的赠送的优惠额不进行结余；如赠送通信费高于实际通信费的，赠送的通信费按活动规则中送费使用有效期规定时限内，可进行结转使用。如未达到赠送条件的，则不进行赠送。（2）赠送终端产品的，客户在营销活动在网期到期前要求提前终止服务的，除将预存费用余额冲抵终端购买款外，客户还应向移动公司支付违约金；客户预存费用余额不足以充抵终端购买款的，移动公司还有权收回终端或要求客户补足终端购买款。（3）赠送电信业务的，在服务期内按月赠送额度内抵扣该业务的服务费用，客户未使用或实际费用额低于赠送额度的，该月的赠送额不进行结余。赠送的电信业务与资费套餐有先后使用顺序的，优先使用套餐费用，再使用赠送的电信业务。（4）提供价格折扣的，移动公司按约定的折扣提供产品和服务。（5）赠送电子卷、红包的，客户在营销活动在网期到期前要求提前终止服务，赠送的电子卷、红包将按照违反约定要求客户承担其违约责任。',
        '4、赠送费用抵扣范围：可抵扣除通信账户支付以外所有费用。',
        '5、预付费用：客户向移动公司缴纳的用于划拨支付通信消费的费用，包括预存话费、预存增值业务功能费等。客户如果要求提前终止相关业务或活动，或有违反约定的行为的，预付费用将冲抵剩余服务期的月最低消费额、终端款、违约金或其他款项。',
        '6、营销活动在网期：双方约定的参加该项营销活动的最短服务期限（也称合约期），在该期限内，客户按约使用通信服务并支付费用的，则移动公司将按约定给予客户相应的优惠额度。营销活动合约期内，变更资费套餐、过户、更名、销户、携号转网等业务无法进行办理，亦无法叠加办理其他的优惠营销活动（包括但不限于预存话费送话费、预存话费送终端、预存话费送礼品、赠送流量等）。',
        '7、月：移动公司按其业务规范而确定的计费月。',
        '8、通信费：包括月基本费、通话费（含本地、长途、漫游）、短信（含彩信）费、流量费以及客户申请的其他通信业务的费用。',
        '9、信用额度：又称授信额度，即客户在一个计费月周期内允许欠费不停机的最高限额，仅限该计费月周期内有效。',
        '10、全国通用流量：在全国范围内移动2、3、4G网络下使用流量（不含台港澳地区）。',
        '11、流量使用优先级原则：流量套外封顶恢复包->小时/包天套餐-限定APN流量套餐（wap不限量套餐）->内容定向流量套餐->闲时流量套餐->节日包流量->常规资费->国际/港澳台漫游优惠。',      
        '12、流量封顶规则：（1）套外双封顶规则：每月套餐外流量费用500元封顶、套餐外流量30G封顶；即当套餐外流量费用累计达到500元时停止收费，可继续使用流量；当套餐外流量累计达到30BG时，系统会暂停您的上网功能。（2）总流量200G封顶规则：客户当月所使用的流量和达到200G时（包括计费流量、非计费流量、套内、套外等），系统会暂停上网功能，当月不可恢复，下月自动恢复。',
        '13、宽带产品速率说明：',
        '宽带产品     上行速率（bps）    下行速率（bps）',
        '30M           上行10M                 下行30M',
        '50M           上行20M                 下行50M',
        '100M         上行50M                 下行100M',
        '200M         上行50M                 下行200M',
        '300M         上行50M                 下行300M',
        '500M         上行100M               下行500M',
        '注：家庭宽带接入方式为光纤到户（FTTH）或光纤到楼（FTTB），其中光纤到楼（FTTB）最高提供的接入速率为100M。',
        '二、服务约定',
        '1、营销活动在网期内，除非双方就本业务受理单和须知所约定的事项另行达成协议，一方不履行或不完全履行约定义务的，属于违约行为，违约方应向守约方承担违约责任。',
        '2、营销活动合约期内应使用由中国移动通信集团四川有限公司提供的相关通信服务。',
        '3、客户在参加增值业务功能费活动的同时承诺开通相应的增值业务功能，但在营销活动在网期内客户不开通或不使用的，移动公司有权为其开通相应功能，且有权按活动约定标准直接从预交的增值业务功能费中划扣相应的费用。若因此客户未享受到相应的增值业务服务的，移动公司不承担任何责任。',
        '4、客户自行要求提前解除营销活动合约的，双方同意除按本须知前述约定的一般原则处理外，区分具体事项，按以下方式处理：',
        '1）有价赠送活动：',
        'A.送实物类（如终端活动、魔百和购机活动），如活动已履行期≤合约期的一半，客户应返还“总赠送价值”或“实际享受赠送价值”*100%；如活动已履行期过半，客户应返还“总赠送价值”或“实际享受赠送价值”*50%；',
        'B.送业务类（如语音、流量、功能费）按照其赠送业务实际价格进行折算，如活动已履行期≤合约期的一半，客户应返还“总赠送价值”或“实际享受赠送价值”*100%；如活动已履行期过半，客户应返还“总赠送价值”或“实际享受赠送价值”*50%；(流量业务5元/G，语音业务0.12元/分钟，附加资费将按照附加资费月功能费进行折算)；',
        'C.送电子券（电子卷、红包）按照电子券面值实际金额，活动已履行期≤合约期的一半，客户应返还“总赠送价值”或“实际享受赠送价值”*100%；如活动已履行期过半，客户应返还“总赠送价值”或“实际享受赠送价值”*50%；',
        'D.送通信费类，如活动已履行期≤合约期的一半，客户应返还“总赠送价值”或“实际享受赠送价值”*100%；如活动已履行期过半，客户应返还“总赠送价值”或“实际享受赠送价值”*50%；其中，“总赠送价值”的计算方法适用于一次性划拨的活动；“实际享受赠送价值”的计算方法适用于分月划拨的活动；',
        'E．权益赠送类，权益未使用可在完成赠送权益回退后解约；权益已领取、使用，活动已履行期≤合约期的一半，客户应返还“总赠送价值”或“实际享受赠送价值”*100%；如活动已履行期过半，客户应返还“总赠送价值”或“实际享受赠送价值”*50%。',
        '2)承诺低消且享受服务的营销活动：',
        '（如积分赠送、全球通焕新活动）客户提出的诉求在受理审批确认后，原则上立即失效营销活动与相关服务。',
        '3)租用设备活动：客户应通过移动公司指定的自营厅归还完好无损的实物或补偿实物的购买费用后方可终止。',
        '4) 宽带业务：提前终止宽带业务需根据前期活动约定的初装费用或拆机费用进行赔付。',
        '5）融合业务：如融合套餐、主副卡、统付、共享、家庭网、集团网、惠农网、双向亲情互打等业务，需在不影响其他客户业务使用的情况下，根据具体情况进行退订或解除；',
        '如①主卡、共享者解除，应对其他成员尽到通知业务。',
        '②副卡、被共享者解除，不应对其他成员权益造成损失。',
        '6）吉祥号业务：按吉祥号码协议中低消和未履行协议期的相关要求进行赔付。',
        '7）低门槛送新业务营销活动（20元以下业务）：无需赔补，客户提出的诉求在受理审批确认后立即终止。',
        '5、客户须向移动公司出示本人有效身份证件原件（居民身份证、军官（士兵）证、护照）并提供复印件，保证向移动公司提供的全部信息、资料及在本业务受理单上所填写的内容均真实、合法、有效。客户承诺因使用该号码参加相关营销活动而产生的任何责任，包括但不限于该号码的真实使用人或其他任何有依据的第三人主张权利而引起的纠纷，皆由客户本人承担。纠纷未解决前，客户自愿放弃与该号码有关的权益（包括但不限于码号使用权）。',
        '中国移动通信集团四川有限公司'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 5,
        userId: '',
        goodsCode: 'TUIA062900019999'
      },
      channel: 'TUIA',
      showMoreNotice: true,
      dialogVisible: false,
      agreeProtocol: true,
      protocolVisible: false
    }
  },
  mounted () {
    if (this.$route.query.action === 'redirect') {
      location.href = 'https://y.app.10086.cn/YXMB/v3/api/api/pro/2f51a490168a4fe5'
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    handelConfirm() {
      this.dialogVisible = true
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'sichuanSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #41c1ac;
  padding-bottom: 3.5rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  margin-top: 2 rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    background: url('../../assets/images/liaoning/notice-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 2.5rem 2rem 1.2rem;
    border-radius: .4rem;
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #a3a3a3;
    }
  }
}
.form{
  width: 80%;
  margin: 0 auto;
  margin-top: -3rem;
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
    }
  }
}
.protocol-content{
  color: #333;
  margin-left: .5rem;
  .protocol{
    color: rgb(48, 113, 253);
  }
}
.protocol-dialog-content{
  font-size: .6rem;
  text-align: left;
  >div{
    text-indent: 1rem;
  }
}
</style>
